
//Packages
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Typography, Button, Box, Stack, useMediaQuery, Modal, TextField, Alert } from '@mui/material';
import { DataGrid, getDataGridUtilityClass, gridClasses, renderActionsCell } from '@mui/x-data-grid';
import VisibilityIcon from '@mui/icons-material/Visibility';
import IconButton from '@mui/material/IconButton';

// Local
import formatName from '../utilities/formatName';
import formatPhoneNumber from '../utilities/formatPhoneNumber';
import getDayFormatted from '../utilities/getDayFormatted';
import formatTimeRemaining from '../utilities/formatTimeRemaining';
import CountdownTimer from '../utilities/CountdownTimer';

const AllExamsTableTile = ({ rows, onRowClick }) => {
    /*
        parameters:
            rows: array, each index is a dictionary with one user's information
                {
                    'id': int,
                    'userId': int,
                    'username': str,
                    'firstName': str,
                    'lastName': str,
                    'mathScore': float,
                    'languageScore': float,
                    'readingScore': float,
                    'phoneNumber': str,
                    'email': str,
                    'dateTaken': str,
                    'examTokens': int,
                    'examId': int
                    'timeRemaining': int
                }
        
        returns:
            ExamTableTile copmponent which displays the users given in the rows parameter inside an MUI DataGrid Component
    */

    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // DEFINITIONS
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    const isMobile = useMediaQuery("(max-width:600px)");
    const currentDay = getDayFormatted();

    const paginationModel = { page: 0, pageSize: 10 };

    const gridColumns = [
        { flex: 0.75, headerName: 'ID', field: 'id'},
        { flex: 0.75, headerName: 'Test Taker ID', field:'test_taker__id'},
        { flex:1.5, headerName: 'First Name', field: 'test_taker__first_name', renderCell: (params) => <span>{formatName(params.row.test_taker__first_name)}</span> },
        { flex:1.5, headerName: 'Last Name', field: 'test_taker__last_name', renderCell: (params) => <span>{formatName(params.row.test_taker__last_name)}</span> },
        { flex:1, headerName: 'Exam', field: 'exam_component_base__exam_base__exam_title' },
        { flex:1, headerName: 'Component', field: 'exam_component_base__exam_component_title' },
        { flex:0.75, headerName: 'Score', field: 'score'},
        { flex: 1.25, headerName: 'Date Taken (YYYY-MM-DD)', field:'date_taken_local', renderCell: (params) => <span>{params.row.date_taken_local}</span>},
        { flex: 1.5, headerName: 'Expiration', field:'expiration', renderCell: (params) => <CountdownTimer expiration={params.row.expiration}/>},
        { flex: 1, headerName: 'Graded', field:'graded', renderCell: (params) => <span>{params.row.graded ? "Yes" : "No"}</span>},
        {
            field: 'view',
            headerName: '',
            width:60,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => (
                <IconButton
                    onClick={(e) => {
                        e.stopPropagation();
                        onRowClick(params);
                    }}
                    aria-label="view user"
                >
                    <VisibilityIcon />
                </IconButton>
            )
        }
      ];
    



    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // STYLES 
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    const outerBoxStyle = {
        display: 'flex',
        flexDirection: 'column',
        boxShadow: 3,
        borderRadius: 4,
        width:'100%',
        height:'auto',
    };

    const outerBoxStyleMobile = {
        display: 'flex',
        flexDirection: 'column',
        p:2,
        width: '100vw',
        height:'auto',

    };

    const headerStyle = {
        bgcolor: '#3479c8',
        color:'#FFFFFF',
        px:2,
        pt:2,
        borderTopRightRadius:16,
        borderTopLeftRadius:16,
        pb:1,
    }

    const headerTextStyle = {fontWeight:650, textShadow: '2px 2px 4px rgba(0, 0, 0, 0.25)'}

    const gridStyle = {m:1, borderRadius:4, cursor:'pointer'}




    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // HTML COMPONENT
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    return (
        <Box sx={outerBoxStyle}>
            <Box sx={headerStyle}>
                <Typography variant='h4' sx={headerTextStyle}>All Exams</Typography>
            </Box>
            <DataGrid
                sx={gridStyle}
                rows={rows}
                columns={gridColumns}
                initialState={{ 
                    pagination: { paginationModel },
                }}
                disableRowSelectionOnClick
                pageSizeOptions={[10, 30, 50, 100]}
                getCellClassName={(params) => {
                    if (!['score'].includes(params.field)) {
                      return '';
                    };
                    if (params.value === null || params.value === undefined) {
                      return 'null';  // Ensure null or undefined values are caught first
                    };
                    return params.value >= 80.0 ? 'pass' : 'fail';
                  }}
            />
        </Box>
    )
}

export default AllExamsTableTile;